module.exports = __webpack_public_path__ + "static/img/menu5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu5.png
// module id = 559
// module chunks = 0